import React from 'react';
import Swal from 'sweetalert2';
import '../assets/css/Contact.css';

function Contact() {
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://formsubmit.co/ajax/info@peony-technologies.com', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'تم الإرسال!',
          text: 'تم إرسال رسالتك بنجاح.',
          confirmButtonText: 'حسناً'
        });
        form.reset();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'حدث خطأ!',
          text: 'لم يتم إرسال الرسالة. حاول مرة أخرى.',
          confirmButtonText: 'حسناً'
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'خطأ في الاتصال!',
        text: 'تحقق من الاتصال بالإنترنت.',
        confirmButtonText: 'حسناً'
      });
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h1 className="contact-title">تواصل معنا</h1>
        
        <div className="contact-wrapper">
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_subject" value="رسالة جديدة من صفحة تواصل معنا" />

              <input
                type="text"
                name="name"
                placeholder="الاسم الكامل"
                className="contact-input"
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="رقم الهاتف"
                className="contact-input"
                required
              />
              <input
                type="email"
                name="email"
                placeholder="البريد الإلكتروني"
                className="contact-input"
                required
              />
              <textarea
                name="message"
                placeholder="اكتب رسالتك هنا..."
                className="contact-textarea"
                rows="6"
                required
              ></textarea>
              <button type="submit" className="contact-btn">
                إرسال الرسالة
              </button>
            </form>
          </div>

          <div className="contact-map">
            {/* ! التعديل هنا في السطر التالي */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1738249.231221144!2d34.8715296!3d31.9351224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d21168f8a614b%3A0x83b499827051d94!2sPalestine!5e0!3m2!1sen!2sus!4v1626500000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Palestine Map"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;